import { render, staticRenderFns } from "./AddLive.vue?vue&type=template&id=0a49dee8&scoped=true&"
import script from "./AddLive.vue?vue&type=script&lang=js&"
export * from "./AddLive.vue?vue&type=script&lang=js&"
import style0 from "./AddLive.vue?vue&type=style&index=0&id=0a49dee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a49dee8",
  null
  
)

export default component.exports